export default __webpack_public_path__ + "static/media/papaerclip.d37aecc4.svg";